import React, { useState } from 'react';
import './DemoForm.css';

export default function DemoForm() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    schoolName: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const subject = encodeURIComponent('Demo Request - Absolute Vision');
    const body = encodeURIComponent(
      `New Demo Request:\n\n` +
      `Name: ${formData.fullName}\n` +
      `Email: ${formData.email}\n` +
      `Phone: ${formData.phone}\n` +
      `School: ${formData.schoolName}\n` +
      `Date: ${new Date().toLocaleString()}`
    );
    
    window.open(`mailto:contact@absolutevision.co.in?subject=${subject}&body=${body}`, '_blank');
    
    setSubmitted(true);
    setFormData({ fullName: '', email: '', phone: '', schoolName: '' });
    
    setTimeout(() => {
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.header}>
          <h1 style={styles.title}>Book a Free Demo</h1>
          <p style={styles.subtitle}>See Absolute Vision in action! Schedule a personalized demo.</p>
        </div>
        
        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Full Name</label>
              <input
                type="text"
                name="fullName"
                placeholder="John Doe"
                value={formData.fullName}
                onChange={handleChange}
                required
                style={styles.input}
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.label}>Email Address</label>
              <input
                type="email"
                name="email"
                placeholder="you@school.edu"
                value={formData.email}
                onChange={handleChange}
                required
                style={styles.input}
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.label}>Phone Number</label>
              <input
                type="tel"
                name="phone"
                placeholder="+91 98765 43210"
                value={formData.phone}
                onChange={handleChange}
                required
                style={styles.input}
              />
            </div>
            
            <div style={styles.formGroup}>
              <label style={styles.label}>School Name</label>
              <input
                type="text"
                name="schoolName"
                placeholder="Your School Name"
                value={formData.schoolName}
                onChange={handleChange}
                required
                style={styles.input}
              />
            </div>
            
            <button type="submit" style={styles.button}>Schedule Demo</button>
          </form>
        ) : (
          <div style={styles.successMessage}>
            ✅ Thank you! Your demo request has been sent. Our team will contact you within 24 hours.
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  page: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px',
  },
  container: {
    background: 'white',
    borderRadius: '24px',
    padding: '48px',
    maxWidth: '500px',
    width: '100%',
    boxShadow: '0 30px 60px rgba(0, 0, 0, 0.3)',
  },
  header: {
    marginBottom: '32px',
  },
  title: {
    fontSize: '32px',
    fontWeight: '900',
    background: 'linear-gradient(135deg, #2563EB, #7C3AED)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
    marginBottom: '12px',
  },
  subtitle: {
    fontSize: '16px',
    color: '#64748B',
    margin: 0,
  },
  formGroup: {
    marginBottom: '20px',
  },
  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: '#1E293B',
    marginBottom: '8px',
  },
  input: {
    width: '100%',
    padding: '12px 16px',
    border: '1px solid #E2E8F0',
    borderRadius: '12px',
    fontSize: '14px',
    fontFamily: "'Inter', sans-serif",
    transition: 'all 0.3s',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '14px 24px',
    background: 'linear-gradient(135deg, #2563EB, #7C3AED)',
    color: 'white',
    border: 'none',
    borderRadius: '12px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.3s',
    marginTop: '24px',
  },
  successMessage: {
    padding: '16px',
    background: '#D1FAE5',
    color: '#065F46',
    borderRadius: '12px',
    marginTop: '16px',
    textAlign: 'center',
    fontWeight: '600',
  },
};
